import styles from './ValidationMessage.module.css';
import { BaseProps } from '../../common/BaseProps';

interface Props extends BaseProps {
  text: string;
  type?: string;
}

const ValidationMessage: React.FC<any> = (props: Props) => {
  const { text, type = 'error' } = props;

  return (
    <div className={`${styles.container} ${styles[type]}`}>
      {type === 'error' && <i className="fas fa-times-circle"></i>}
      <span>{text}</span>
    </div>
  );
};

export default ValidationMessage;
